module.exports = {
  __depends__: [ require(108) ],
  __init__: [ 'directEditing' ],
  directEditing: [ 'type', require(74) ]
};